module.exports = __webpack_public_path__ + "img/64.9.TU.f893d24a.png";